<template>
    <div class="subscription-details">
        <select-plan/>
        <!-- <select-product /> -->
        <coupon-section class="subscription-details--coupon"/>
        <submit-button
            @click="submitCurrentStep"
            class="subscription-details--button"
            :processing="isFormProcessing"
            color="green">
            {{ $t('REGISTER_BUTTON_NEXT') }}
        </submit-button>
        <alt-trust-pilot step="cardDetails" class="subscription-details--trust-pilot"/>
        <simple-footer />
    </div>
</template>

<script>
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import IncompleteRegistrationService from '@/services/users/incompleteRegistrationService/IncompleteRegistrationService';
import selectPlan from '@/components/forms/register/SelectPlan';
// import selectProduct from '@/components/forms/register/SelectProduct';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import CouponSection from '@/components/forms/fields/CouponSection';
import SimpleFooter from '@/components/structure/SimpleFooter';
import AltTrustPilot from '@/components/forms/fields/AltTrustPilot';

export default {
    name: 'SubscriptionDetails',
    components: {
        selectPlan,
        // selectProduct,
        SubmitButton,
        CouponSection,
        SimpleFooter,
        AltTrustPilot,
    },
    data: () => {
        return {
            isFormProcessing: false,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    mounted() {
        this.$store.dispatch('subscription/fetchAvailableDeliveryDay', 'W127fP');
    },
    methods: {
        submitCurrentStep() {
            this.errorHandler.reset();
            this.isFormProcessing = true;
            setTimeout(() => (new IncompleteRegistrationService()).updateOrCreate(), 0);
            this.$router.push({ name: 'register.delivery-details' });
        },
    },
};
</script>

<style lang="scss" scoped>
.subscription-details {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    &--button {
        width: 90%;
        margin: 20px 0;
        min-width: 100px;
    }
    &--coupon {
        @media screen and (min-width: 640px) {
            display: none;
        }
    }
    &--trust-pilot {
        margin-top: 50px;
        width: 100%;
    }
}
</style>
